export default () => {
    return (
        window.innerWidth >= 1366 ? 'large' :
        window.innerWidth >= 800 ? 'medium' :
        'small'
    )
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/Utils/GetMode.ts